import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-manage",
  "use": "icon-manage-usage",
  "viewBox": "0 0 14.621 14.621",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14.621 14.621\" id=\"icon-manage\">\r\n  <path id=\"icon-manage_管理\" class=\"cls-1\" d=\"M147.2,154.062l1.475-.9,5.836,3.527,5.835-3.527,1.475.9-7.31,4.425Zm0-2.886,7.31-3.976,7.31,3.976-7.31,3.976Zm7.31,8.849,5.835-3.527,1.475.9-7.31,4.425L147.2,157.4l1.475-.9Z\" transform=\"translate(-147.2 -147.2)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol